import React from 'react'
import './record-line.scss'
import { Column, Row } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'

export interface RecordLineItem {
    time: string
    content: React.ReactNode
    key: any
}

interface RecordLineProps {
    record: RecordLineItem[]
}

const RecordLine: React.FC<RecordLineProps> = props => {
    const cls = useBemClass('record-line')

    return (
        <Column data-width-100p>
            {props.record.map((r, index) => {
                const isLast = index === props.record.length - 1

                return (
                    <div key={r.key} className={cls('item')}>
                        <Row data-align-items-center data-height-20 data-justify-content-space-between>
                            <Row data-align-items-center>
                                <div
                                    className={cls('dot')}
                                    style={{
                                        background: isLast ? 'linear-gradient(#03d3c4, #44e1a6)' : '#f0f0f0',
                                    }}
                                />
                                <div
                                    data-font-size-14
                                    data-margin-left-12
                                    style={{
                                        fontWeight: isLast ? 600 : 400,
                                        color: isLast ? '#14CC9B' : '#999',
                                    }}
                                >
                                    {r.time}
                                </div>
                            </Row>
                            <div
                                style={{
                                    fontWeight: isLast ? 600 : 400,
                                    color: isLast ? '#14CC9B' : '#000',
                                }}
                                data-font-size-14
                            >
                                {r.content}
                            </div>
                        </Row>
                    </div>
                )
            })}
        </Column>
    )
}

export default RecordLine
